<!-- body section -->
<div class="otp-section">
    <div class="otp-wrapper">
        <div class="otp-back d-flex align-items-center cursor-pointer" (click)="goBack()">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="9" viewBox="0 0 14 9" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M14 4.5C14 4.22386 13.7761 4 13.5 4L1.70711 4L4.85355 0.853554C5.04882 0.658292 5.04882 0.341708 4.85355 0.146446C4.65829 -0.0488167 4.34171 -0.0488167 4.14645 0.146446L0.146446 4.14645C-0.0488157 4.34171 -0.0488157 4.65829 0.146446 4.85355L4.14645 8.85355C4.34171 9.04882 4.65829 9.04882 4.85355 8.85355C5.04882 8.65829 5.04882 8.34171 4.85355 8.14645L1.70711 5L13.5 5C13.7761 5 14 4.77614 14 4.5Z"
                    fill="#2B2B2B" />
            </svg>
            <button id="btn_auxElement_cellphoneVerification_back_OTPscreen" class="back-btn" >Back</button>

        </div>
        <div class="px-0 px-md-2">
            <div *ngIf="otpErrorMsg!=''" class="alert alert-danger otp-err-msg" role="alert">
                {{otpErrorMsg}}
            </div>
            <div *ngIf="successMsg!='' && successMsg!=null" class="alert otp-success-msg" role="alert">
                {{successMsg}}
            </div>
            <div *ngIf="successMsgWithPipe == true" class="alert alert-success otp-success-msg" role="alert">
                Your session will expire in {{counter | formatTime }}.
            </div>
        </div>
        <div class="otp-card">
            <div class="otp-container">
                <div class="form-group">
                    <div class="text-center">
                        <div class="modal-title ftsz mt-0 m-3" id="modal-basic-title">
                            OTP <span class="secondary-text">verification</span>
                        </div>
                        <p class="text-charcl">Please enter the 6-digit OTP sent to <span
                                class="d-block d-sm-inline">{{maskedPhoneNumber}}</span></p>
                    </div>
                </div>
                <form [formGroup]="otpForm">
                    <div class="form-group">
                        <div class="form-field text-center">
                            <div class="passcode-wrapper">
                                <input #otpInput formControlName="Otp" id="txt_registration_OTP1" type="text"
                                    maxlength="1" (keyup)="onKeyUpEvent($event, 1)" (focus)="onFocusEvent(1)"
                                    (input)="onKeyUpEvent($event, 1)" pattern="[0-9]*" inputmode="numeric">
                                <input #otpInput formControlName="Otp" id="txt_registration_OTP2" type="text"
                                    maxlength="1" (keyup)="onKeyUpEvent($event, 2)" (focus)="onFocusEvent(2)"
                                    (input)="onKeyUpEvent($event, 2)" pattern="[0-9]*" inputmode="numeric">
                                <input #otpInput formControlName="Otp" id="txt_registration_OTP3" type="text"
                                    maxlength="1" (keyup)="onKeyUpEvent($event, 3)" (focus)="onFocusEvent(3)"
                                    (input)="onKeyUpEvent($event, 3)" pattern="[0-9]*" inputmode="numeric">
                                <input #otpInput formControlName="Otp" id="txt_registration_OTP4" type="text"
                                    maxlength="1" (keyup)="onKeyUpEvent($event, 4)" (focus)="onFocusEvent(4)"
                                    (input)="onKeyUpEvent($event, 4)" pattern="[0-9]*" inputmode="numeric">
                                <input #otpInput formControlName="Otp" id="txt_registration_OTP5" type="text"
                                    maxlength="1" (keyup)="onKeyUpEvent($event, 5)" (focus)="onFocusEvent(5)"
                                    (input)="onKeyUpEvent($event, 5)" pattern="[0-9]*" inputmode="numeric">
                                <input #otpInput formControlName="Otp" id="txt_registration_OTP6" type="text"
                                    maxlength="1" (keyup)="onKeyUpEvent($event, 6)" (focus)="onFocusEvent(6)"
                                    (input)="onKeyUpEvent($event, 6)" pattern="[0-9]*" inputmode="numeric">
                            </div>
                        </div>
                    </div>
                </form>

                <div class="modal-footer flex-wrap justify-content-center pb-0 border-0 pt-0">
                   
                    <div class="d-flex justify-content-center flex-wrap">
                        <div
                            [ngClass]="hideResendOTPButton === true ?  'd-none' : 'text-center mt-2 w-100 charcl d-block' ">
                            <div class="mobfx">No OTP received?</div>
                            <span class="ms-1" *ngIf="secondsLeft > 0"> Request resend</span>
                            <button id="btn_auxElement_cellphoneVerification_resendOTP_OTPscreen" type="button"
                                class="resendotpbtn ms-1 fw-bold" [disabled]="disableOTPSendButton == true"
                                *ngIf="secondsLeft === 0" (click)="sendOtp(1)">Resend
                            </button> <span class="ms-1" *ngIf="secondsLeft > 0">in {{secondsLeft}}s</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
